import React from "react";
import "./index.css";
import { isMobile } from "react-device-detect";
import { Typography } from "antd";

const { Title, Paragraph } = Typography;

type AuthFormProps = {
  title: string;
  subtitle: string;
  description: string;
};

export const AuthForm: React.FC<AuthFormProps> = ({
  title,
  subtitle,
  description,
  children,
}) => (
  <div className={isMobile ? "auth-form-mobile" : "auth-form-browser"}>
    <Title className="auth-form-title">{title}</Title>
    <Title level={4}>{subtitle}</Title>
    <Paragraph>{description}</Paragraph>
    {children}
  </div>
);
